import { ArchiveBoxIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";

const ArchiveWrapper = ({ organisation }) => {
	return (
		<div
			style={{
				backgroundColor: "#ea611c",
				borderColor: "#ea611c",
				lineHeight: "34px",
				width: "100%",
				color: "white",
				paddingLeft: "15px",
				paddingRight: "15px",
			}}
		>
			<ArchiveBoxIcon style={{ height: "1.5em", float: "left", marginRight: 5, marginTop: 5 }} />
			{organisation} is currently archived. You only have read access to historical reports.
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
        organisation: state.company.settings.name
    };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveWrapper);
